import"./Radio.css.ts.vanilla.css";var _={container:"Radio_styles_container__1oqmh2k0",input:"Radio_styles_input__1oqmh2k1",checkmark:"Radio_styles_checkmark__1oqmh2k2",hiddenLabel:"Radio_styles_hiddenLabel__1oqmh2k3"};export{_ as styles};
//# sourceMappingURL=Radio.css.vanilla.js.map
